<template>
  <div id="settlement">
    <div class="opreationBox">
      <el-form
        :inline="true"
        :model="formInline"
        class="demo-form-inline"
        label-width="100px"
      >
        <el-form-item
          label="充值状态"
          label-width="100px"
        >
          <el-select
            v-model="formInline.RechargeState"
            placeholder="请选择充值状态"
            @change="handleCurrentChange(1)"
          >
            <el-option
              v-for="item in RechargeStateList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label=""
          label-width=""
        >
          <el-button
            type="primary"
            @click="addSettlementPrice"
          >生成结算</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="tableBox">
      <el-table
        v-loading="loading"
        :height="tableH"
        :data="desList"
        border
        style="width: 100%"
      >
        <el-table-column
          header-align="center"
          align="center"
          label="结算金额"
          prop="settlementPrice"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="结算类型"
          prop="settlementType"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="是否充值"
        >
          <template slot-scope="scope">
            <template v-for="(item,index) in RechargeStateList">
              <span
                :key="index"
                :style="{color:item.color}"
                v-if="item.value==scope.row.isRecharge"
              >{{ item.label}}</span>
            </template>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="创建时间"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.createTime}}</span>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="充值时间"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.rechargeTime}}</span>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          fixed="right"
          label="操作"
          width="150"
        >
          <template slot-scope="scope">
            <!-- <el-button
              :disabled="Boolean(scope.row.isRecharge)"
              :type="Boolean(scope.row.isRecharge)?'':'success'"
              size="mini"
              plain
              @click="updateRecharge(scope.row.id)"
            >充值</el-button> -->
            <el-button
              @click="openDes(scope.row)"
              size="mini"
              plain
            >结算明细</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pageBox">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageObj.PageIndex"
        :page-sizes="[2, 4, 10, 20, 50, 100]"
        :page-size="pageObj.PageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageObj.total"
      >
      </el-pagination>
    </div>
    <settlementDialog
      v-if="dialogDesVisible"
      :showDes.sync="dialogDesVisible"
      :desObj="desObj"
    ></settlementDialog>
  </div>
</template>

<script>
import { getFinance, settlementPrice, updateRechargeState } from 'api/request'
import { SetTableH } from '../../utils/utils'
import settlementDialog from './components/settlementDialog'
export default {
  data() {
    return {
      loading: true,
      tableH: '250',
      dialogDesVisible: false,
      desObj: null,
      formInline: {
        RechargeState: -1
      },
      pageObj: {
        total: 0,
        PageIndex: 1,
        PageSize: 10
      },
      RechargeStateList: [
        {
          value: -1,
          label: '全部',
          color: ''
        },
        {
          value: 0,
          label: '未充值',
          color: '#f56c6c'
        },
        {
          value: 1,
          label: '已充值',
          color: '#67c23a'
        }
      ],
      desList: []
    }
  },
  components: {
    settlementDialog
  },
  methods: {
    handleSizeChange(val) {
      this.pageObj.PageSize = val
      this.getFinanceList()
    },
    handleCurrentChange(val) {
      this.pageObj.PageIndex = val
      this.getFinanceList()
    },
    async getFinanceList() {
      let params = {
        PageIndex: this.pageObj.PageIndex,
        PageSize: this.pageObj.PageSize,
        RechargeState: this.formInline.RechargeState
      }
      this.loading = true
      let data = await getFinance(params)
      if (data) {
        this.desList = data.rows
        this.pageObj.total = data.total
        this.loading = false
      }
    },
    async addSettlementPrice() {
      let data = await settlementPrice()
      if (data) {
        this.$message({
          message: '更新成功',
          type: 'success'
        })
        this.getFinanceList()
      }
    },
    async updateRecharge(id) {
      this.$confirm(
        `请你确定卡里有足够金额支付这次结算，是否继续进行充值操作?`,
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      )
        .then(() => {
          updateRechargeState(id).then(data => {
            if (data) {
              this.$message({
                message: '已充值成功',
                type: 'success'
              })
              this.getFinanceList()
            } else {
              this.$message({
                message: '充值失败',
                type: 'error'
              })
            }
          })
        })
        .catch(() => {})
    },
    openDes(data) {
      this.desObj = data
      this.dialogDesVisible = true
    }
  },
  mounted() {
    SetTableH(this)
  },
  created() {
    this.getFinanceList()
  }
}
</script>
<style lang='scss'>
#settlement {
  height: 100%;
  width: 100%;
  .formBox {
    width: 200px;
  }
  .pageBox {
    margin-top: 20px;
    text-align: right;
  }
}
</style>
